module.exports = __webpack_public_path__ + "static/media/corporateclone.adbb4d68.JPG";